<span [ngStyle]="theme"></span>
